import { Injectable } from '@angular/core';

import type {
	GetGeolocationPhotoRequest,
	LookupTextGeolocationRequest,
} from '@reach/interfaces/geolocation/geolocation.requests';
import type {
	GetGeolocationPhotoResponse,
	LookupTextGeolocationResponse,
} from '@reach/interfaces/geolocation/geolocation.responses';

import { BaseApiService } from '~app-client/api/_internal';

@Injectable({ providedIn: 'root' })
export class GeolocationApiService extends BaseApiService {
	protected commonPath = ['geolocation'];

	public async lookupText(text: string): Promise<LookupTextGeolocationResponse> {
		const body: LookupTextGeolocationRequest = { text };
		return await this.http.post<LookupTextGeolocationResponse>(this.url('lookup-text'), body);
	}

	public async getPhotoUrl(name: string): Promise<string | null> {
		const params = { name } satisfies GetGeolocationPhotoRequest;
		const response = await this.http.get<GetGeolocationPhotoResponse>(
			this.url('photo'),
			params
		);
		return response.url;
	}
}
